import { render, staticRenderFns } from "./LotteryConfigPane.vue?vue&type=template&id=60c0e287&scoped=true"
import script from "./LotteryConfigPane.vue?vue&type=script&lang=js"
export * from "./LotteryConfigPane.vue?vue&type=script&lang=js"
import style0 from "./LotteryConfigPane.vue?vue&type=style&index=0&id=60c0e287&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c0e287",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60c0e287')) {
      api.createRecord('60c0e287', component.options)
    } else {
      api.reload('60c0e287', component.options)
    }
    module.hot.accept("./LotteryConfigPane.vue?vue&type=template&id=60c0e287&scoped=true", function () {
      api.rerender('60c0e287', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/Lottery/LotteryConfigPane.vue"
export default component.exports